import React from 'react';

type ProviderReviewsProps = {
	name: string;
};

const ProviderReviews = (props: ProviderReviewsProps): JSX.Element => {
	const { name } = props;
	return <div>ProviderReviews {name}</div>;
};

export default ProviderReviews;
